import React, { useRef, useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import useIntersection from './useIntersection'; // Ensure the path is correct
import './animations.css'; // Import the CSS for animations

const withLazyLoad = (Component) => {
  return (props) => {
    const [hasRendered, setHasRendered] = useState(false);
    const ref = useRef();
    const isVisible = useIntersection(ref);

    useEffect(() => {
      if (isVisible) {
        setHasRendered(true);
      }
    }, [isVisible]);

    return (
      <div ref={ref} style={{ overflow: 'hidden' }}>
        <CSSTransition
          in={hasRendered}
          timeout={500} // Ensure the timeout matches the transition duration
          classNames="slide-bottom"
          unmountOnExit={false}
        >
          <div style={{ visibility: hasRendered ? 'visible' : 'hidden' }}>
            <Component {...props} />
          </div>
        </CSSTransition>
      </div>
    );
  };
};

export default withLazyLoad;
